"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.293 0.293962C6.48049 0.106422 6.73481 0.0010332 7 0.000976562H15C15.7956 0.000976563 16.5587 0.317031 17.1213 0.879613C17.6839 1.44219 18 2.20522 18 3.00083V19C18 19.7956 17.6839 20.5587 17.1213 21.1213C16.5587 21.6838 15.7956 21.9999 15 21.9999H3C2.20435 21.9999 1.44129 21.6838 0.87868 21.1213C0.316071 20.5587 0 19.7956 0 19V7.00063C5.66374e-05 6.73545 0.105451 6.48115 0.293 6.29366L6.293 0.293962ZM15 2.00088H8V7.00063C8 7.26583 7.89464 7.52017 7.70711 7.7077C7.51957 7.89523 7.26522 8.00058 7 8.00058H2V19C2 19.2652 2.10536 19.5196 2.29289 19.7071C2.48043 19.8946 2.73478 20 3 20H15C15.2652 20 15.5196 19.8946 15.7071 19.7071C15.8946 19.5196 16 19.2652 16 19V3.00083C16 2.73562 15.8946 2.48128 15.7071 2.29376C15.5196 2.10623 15.2652 2.00088 15 2.00088ZM3.414 6.00068H6V3.41481L3.414 6.00068Z",
    fill: fill
  }));
};

exports["default"] = _default;